// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Flex } from '@aws-amplify/ui-react';

import OrderListPage from './pages/OrderListPage';
import CreateOrderPage from './pages/CreateOrderPage';
import ViewOrderPage from './pages/ViewOrderPage';
import UpdateOrderPage from './pages/UpdateOrderPage';
import JobScheduleControlPage from './pages/JobScheduleControlPage';

export default function App() {
    return (
        <Router>
            <Flex as="nav" padding="1rem" justifyContent="space-between">
                <div>
                    <Link to="/">Home</Link> |{' '}
                    <Link to="/create">Create Order</Link> |{' '}
                    <Link to="/schedule">Schedule</Link>
                </div>
            </Flex>

            <Routes>
                <Route path="/" element={<OrderListPage />} />
                <Route path="/create" element={<CreateOrderPage />} />
                <Route path="/orders/:id" element={<ViewOrderPage />} />
                <Route path="/update/:id" element={<UpdateOrderPage />} />
                <Route path="/schedule" element={<JobScheduleControlPage />} />
            </Routes>
        </Router>
    );
}
